<ng-container *transloco="let t">
<div class="row">
  <div class="col-md-12">
    <!-- Desktop: task section wrapper card (hidden on mobile) -->
    <div class="task-section-card d-none d-md-block">
      <!-- Summary stat blocks -->
      <div class="task-stat-bar">
        <a href="javascript:void(0)" class="task-stat-block" [class.task-stat-active]="selectedTab == 1"
          (click)="setSelectedApplicationTasks(1)">
          <span class="task-stat-count task-stat-outstanding">{{ filteredApplicationTasks.requested.length }}</span>
          <span class="task-stat-label">{{ t('portal.tasks.outstanding') }}</span>
        </a>
        <a href="javascript:void(0)" class="task-stat-block" [class.task-stat-active]="selectedTab == 2"
          (click)="setSelectedApplicationTasks(2)">
          <span class="task-stat-count task-stat-submitted">{{
            filteredApplicationTasks.submitted.length +
            filteredApplicationTasks.approved.length
          }}</span>
          <span class="task-stat-label">{{ t('portal.tasks.submitted') }}</span>
        </a>
        @if (!application.documentLockerHiddenOnPortals) {
          <a href="javascript:void(0)" class="task-stat-block" [class.task-stat-active]="selectedTab == 3"
            (click)="setSelectedApplicationTasks(3)">
            <span class="task-stat-count task-stat-docs">{{ documents.length }}</span>
            <span class="task-stat-label">{{ t('portal.tasks.documents') }}</span>
          </a>
        }
        @if (!isAgent && !application.scenariosHiddenOnPortals) {
          <a href="javascript:void(0)" class="task-stat-block" [class.task-stat-active]="selectedTab == 4"
            (click)="setSelectedApplicationTasks(4)">
            <span class="task-stat-count task-stat-scenarios">{{ scenarios.length }}</span>
            <span class="task-stat-label">{{ t('portal.tasks.scenarios') }}</span>
          </a>
        }
        @if (otherBorrowersOnLoan.length > 0) {
          <div class="task-stat-filter ms-auto">
            <select [(ngModel)]="selectedBorrowerId" (ngModelChange)="onSelectedBorrowerChanged()" class="form-select">
              <option value="all">{{ t('portal.tasks.showAllBorrowers') }}</option>
              <option [ngValue]="application.myDetails.borrowerId">
                {{ application.myDetails.borrowerName }}
              </option>
              @for (borrower of otherBorrowersOnLoan; track borrower.borrowerId) {
                <option [ngValue]="borrower.borrowerId">
                  {{ borrower.borrowerName }}
                </option>
              }
            </select>
          </div>
        }
      </div>

      <!-- Desktop: task card content area inside the card wrapper -->
      <div class="task-section-content">
        <ng-template [ngTemplateOutlet]="taskCardView"></ng-template>
      </div>
    </div>

    <!-- Mobile: original tab navigation (hidden on desktop) -->
    <ul class="nav nav-stretch nav-line-tabs nav-line-tabs border-transparent fs-5 fw-bold d-md-none">
      <li class="nav-item mt-2">
        <a [ngClass]="selectedTab == 1 ? 'active' : ''" class="nav-link task-tab-link ms-0 me-10 py-2"
          href="javascript:void(0)" (click)="setSelectedApplicationTasks(1)">
          {{ t('portal.tasks.outstanding') }}
          <span class="badge rounded-pill bg-danger ms-2">
            {{ filteredApplicationTasks.requested.length }}
          </span>
        </a>
      </li>
      <li class="nav-item mt-2">
        <a [ngClass]="selectedTab == 2 ? 'active' : ''" class="nav-link task-tab-link ms-0 me-10 py-2"
          href="javascript:void(0)" (click)="setSelectedApplicationTasks(2)">
          {{ t('portal.tasks.submitted') }}
          <span class="badge rounded-pill bg-info ms-2">
            {{
            filteredApplicationTasks.submitted.length +
            filteredApplicationTasks.approved.length
            }}
          </span>
        </a>
      </li>
      @if (!application.documentLockerHiddenOnPortals) {
        <li class="nav-item mt-2">
          <a [ngClass]="selectedTab == 3 ? 'active' : ''" class="nav-link task-tab-link ms-0 me-10 py-2"
            href="javascript:void(0)" (click)="setSelectedApplicationTasks(3)">
            {{ t('portal.tasks.documentLocker') }}
            <span class="badge rounded-pill bg-success ms-2">
              {{ documents.length }}
            </span>
          </a>
        </li>
      }
      @if (!isAgent && !application.scenariosHiddenOnPortals) {
        <li class="nav-item mt-2">
          <a [ngClass]="selectedTab == 4 ? 'active' : ''" class="nav-link task-tab-link ms-0 me-10 py-2"
            href="javascript:void(0)" (click)="setSelectedApplicationTasks(4)">
            {{ t('portal.tasks.scenarios') }}
            <span class="badge rounded-pill bg-primary ms-2">
              {{ scenarios.length }}
            </span>
          </a>
        </li>
      }
    </ul>
    @if (otherBorrowersOnLoan.length > 0) {
      <div class="mobile-borrower-filter d-md-none">
        <select [(ngModel)]="selectedBorrowerId" (ngModelChange)="onSelectedBorrowerChanged()" class="form-select">
          <option value="all">{{ t('portal.tasks.showAllBorrowers') }}</option>
          <option [ngValue]="application.myDetails.borrowerId">
            {{ application.myDetails.borrowerName }}
          </option>
          @for (borrower of otherBorrowersOnLoan; track borrower.borrowerId) {
            <option [ngValue]="borrower.borrowerId">
              {{ borrower.borrowerName }}
            </option>
          }
        </select>
      </div>
    }
  </div>
  <div class="col-md-12 mt-3">
    <!-- Reusable template for rendering a task group by its borrowerTaskType -->
    <ng-template #taskGroupRenderer let-taskGroup>
      @switch (taskGroup[0]?.borrowerTaskType) {
        @case ('OnlineApplication') {
          <div>
            <tasks-online-app [tasks]="taskGroup" [application]="application" [isSubmitted]="selectedTab == 2" [isAgent]="isAgent"></tasks-online-app>
          </div>
        }

        @case ('DigitalAssetVerification') {
          <div>
            <tasks-assets
              [tasks]="taskGroup"
              [application]="application"
              [showAssetsButton]="!isAgent"
              (openAssetsClicked)="startAssetsVerification($event)"
              [isSubmitted]="selectedTab == 2"
              >
            </tasks-assets>
          </div>
        }
        @case ('WebsiteLink') {
          <div>
            <tasks-website-link
              [tasks]="taskGroup"
              [application]="application"
              (openWebsiteLinkClicked)="openWebsiteLinkModal($event)"
              [isSubmitted]="selectedTab == 2"
              >
            </tasks-website-link>
          </div>
        }

        @case ('DigitalIncomeEmploymentVerification') {
          <div>
            <tasks-income-employment
              [tasks]="taskGroup"
              [application]="application"
              [showIncomeEmploymentVerificationButton]="!isAgent"
              (startIncomeEmploymentVerificationClicked)="startIncomeEmploymentVerification($event)"
              [isSubmitted]="selectedTab == 2">
            </tasks-income-employment>
          </div>
        }

        @case ('RequestHoi') {
          <div>
            <tasks-hoi [tasks]="taskGroup" [application]="application"></tasks-hoi>
          </div>
        }

        @case ('RequestInformation') {
          @if (!isAgent) {
            <tasks-answer-question
              [tasks]="taskGroup"
              [application]="application"
              (borrowerAnsweredAQuestion)="onBorrowerAnsweredAQuestion($event)"
              [isSubmitted]="selectedTab == 2">
            </tasks-answer-question>
          }
        }

        @default {
          <div>
            <tasks-normal
              [tasks]="taskGroup"
              [application]="application"
              [isBorrowerPortal]="!isAgent"
              [enabledTaskIdForESign]="losEsignTaskIdToSignFirst"
              [doNotEnforceChronologicalOrder]="doNotEnforceChronologicalOrderInEsignTasks"
              (openPaymentInfoClicked)="openPaymentInfo($event)"
              (openEsignDocumentClicked)="openEsignDocument($event)"
              (openAddFilesClicked)="openAddFiles($event)"
              (openAttachedDocumentsClicked)="openAttachedDocuments($event)"
              (taskMarkedAsNotApplicable)="onTaskMarkedAsNotApplicable($event)"
              (openCreditAuthConsentClicked)="openCreditAuthConsent($event)"
              [isSubmitted]="selectedTab == 2">
            </tasks-normal>
          </div>
        }
      }
    </ng-template>

    <ng-template #taskCardView class="container">
      @if (!isLoadingTasks) {
        @if (selectedApplicationTasks) {

          <!-- Mobile: borrower-grouped view when multiple borrowers exist -->
          @if (hasMultipleBorrowers && borrowerSections.length > 0) {
            <div class="mobile-borrower-grouped-view">
              @for (section of borrowerSections; track section.borrowerId) {
                <div class="mobile-borrower-section">
                  <div class="mobile-borrower-header">
                    <span class="mobile-borrower-avatar">{{ section.borrowerName?.charAt(0) }}</span>
                    <span class="mobile-borrower-name">{{ section.borrowerName }}</span>
                    <span class="mobile-borrower-task-count">{{ section.taskGroups.length }} {{ section.taskGroups.length !== 1 ? t('portal.tasks.taskPlural') : t('portal.tasks.taskSingular') }}</span>
                  </div>
                  @for (taskGroup of section.taskGroups; track taskGroup[0]?.taskId) {
                    <ng-container *ngTemplateOutlet="taskGroupRenderer; context: { $implicit: taskGroup }"></ng-container>
                  }
                </div>
              }
            </div>
          }

          <!-- Desktop view (always shown) / Mobile view when single borrower -->
          <div [class.desktop-only-task-view]="hasMultipleBorrowers && borrowerSections.length > 0">
            @for (taskGroup of groupedTasks; track taskGroup[0]?.taskId) {
              <ng-container *ngTemplateOutlet="taskGroupRenderer; context: { $implicit: taskGroup }"></ng-container>
            }
          </div>

        }
      } @else {
        <progress-indicator [loadingMessage]="t('portal.tasks.loadingTasks')"></progress-indicator>
      }

      @if (!isLoadingDocs) {
        @if (selectedTab === 3) {
          <document-locker-table [documents]="documents"></document-locker-table>
        }
      } @else {
        <progress-indicator [loadingMessage]="t('portal.tasks.loadingDocuments')"></progress-indicator>
      }

      @if (!isLoadingScenarios) {
        @if (selectedTab === 4) {
          <scenarios [scenarios]="scenarios"></scenarios>
        }
      } @else {
        <progress-indicator [loadingMessage]="t('portal.tasks.loadingScenarios')"></progress-indicator>
      }

      @if (selectedTab < 3 &&
          selectedApplicationTasks &&
          selectedApplicationTasks.length === 0 &&
          !isLoadingTasks) {
        <h3 class="text-center my-4">
          {{ t('portal.tasks.noTasks') }}
        </h3>
      }
    </ng-template>

    @if (selectDisplayMode === 'card') {
      <!-- Mobile: task cards below tabs (hidden on desktop where cards are inside the card wrapper) -->
      <div class="d-md-none">
        <ng-template [ngTemplateOutlet]="taskCardView"></ng-template>
      </div>
    }
  </div>
</div>
</ng-container>
